export const SunOffIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			role="presentation"
		>
			<path
				d="M2.5 2.5L17.5 17.5M13.3333 10C13.3333 9.11594 12.9822 8.2681 12.357 7.64298C11.7319 7.01786 10.8841 6.66667 10 6.66667M7.63835 7.6475C7.01354 8.27297 6.66279 9.12102 6.66326 10.0051C6.66373 10.8892 7.01538 11.7369 7.64084 12.3617C8.26631 12.9865 9.11437 13.3372 9.99845 13.3368C10.8825 13.3363 11.7302 12.9846 12.355 12.3592M2.5 10H3.33333M10 2.5V3.33333M16.6667 10H17.5M10 16.6667V17.5M4.66667 4.66667L5.25 5.25M15.3333 4.66667L14.75 5.25M14.75 14.75L15.3333 15.3333M5.25 14.75L4.66667 15.3333"
				stroke="black"
				strokeOpacity="0.54"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
